import { IconType } from 'react-icons';
import {
  SiReact,
  SiAngular,
  SiHtml5,
  SiCss3,
  SiSass,
  SiRedux,
  SiTailwindcss,
  SiMaterialdesign,
  SiStyledcomponents,
  SiAntdesign,
  SiWebpack,
  SiJest,
  SiFigma,
  SiStorybook,
  SiJquery,
  SiBootstrap,
  SiExpress,
  SiMongodb,
  SiNodedotjs,
  SiGooglecloud,
  SiDocker,
  SiKubernetes,
  SiRabbitmq,
  SiFastapi,
  SiPostgresql,
  SiRedis,
  SiFirebase,
  SiScikitlearn,
  SiTensorflow,
  SiPytorch,
  SiKeras,
  SiJupyter,
  SiGooglecolab,
  SiKaggle,
  SiPandas,
  SiNumpy,
  SiJavascript,
  SiTypescript,
  SiPython,
  SiR,
  SiCplusplus,
} from 'react-icons/si';

export interface Skill {
  text: string;
  icon: IconType | null;
}
export const frontendSkills = [
  { text: 'React', icon: SiReact },
  { text: 'Angular', icon: SiAngular },
  { text: 'HTML', icon: SiHtml5 },
  { text: 'CSS', icon: SiCss3 },
  { text: 'Tailwind', icon: SiTailwindcss },
  { text: 'Sass', icon: SiSass },
  { text: 'Redux', icon: SiRedux },
  { text: 'Material UI', icon: SiMaterialdesign },
  { text: 'Styled Components', icon: SiStyledcomponents },
  { text: 'Ant Design', icon: SiAntdesign },
  { text: 'Webpack', icon: SiWebpack },
  { text: 'Jest', icon: SiJest },
  { text: 'Figma', icon: SiFigma },
  { text: 'Storybook', icon: SiStorybook },
  { text: 'jQuery', icon: SiJquery },
  { text: 'Bootstrap', icon: SiBootstrap },
];

export const backendSkills = [
  { text: 'Express', icon: SiExpress },
  { text: 'MongoDB', icon: SiMongodb },
  { text: 'node.js', icon: SiNodedotjs },
  { text: 'AWS', icon: null },
  { text: 'Google Cloud', icon: SiGooglecloud },
  { text: 'Docker', icon: SiDocker },
  { text: 'Kubernetes', icon: SiKubernetes },
  { text: 'RabbitMQ', icon: SiRabbitmq },
  { text: 'REST APIs', icon: null },
  { text: 'SQL / NoSQL', icon: null },
  { text: 'MySQL', icon: null },
  { text: 'FastAPI', icon: SiFastapi },
  { text: 'PostgreSQL', icon: SiPostgresql },
  { text: 'Redis', icon: SiRedis },
  { text: 'Firebase', icon: SiFirebase },
];

export const aiSkills = [
  { text: 'Scikit-learn', icon: SiScikitlearn },
  { text: 'TensorFlow', icon: SiTensorflow },
  { text: 'PyTorch', icon: SiPytorch },
  { text: 'Keras', icon: SiKeras },
  { text: 'Jupyter Notebook', icon: SiJupyter },
  { text: 'Google Colab', icon: SiGooglecolab },
  { text: 'Kaggle', icon: SiKaggle },
  { text: 'Pandas', icon: SiPandas },
  { text: 'NumPy', icon: SiNumpy },
];

export const programmingLanguages = [
  { text: 'Javascript', icon: SiJavascript },
  { text: 'Typescript', icon: SiTypescript },
  { text: 'Python', icon: SiPython },
  { text: 'R', icon: SiR },
  { text: 'C++', icon: SiCplusplus },
  { text: 'C#', icon: null },
];
